module.exports = __webpack_public_path__ + "media/anim1.f3de4e2a.mp4";